export const BLOB_CONFIG = {
  background: '#ffffff',
  gradientMap: '4',
  gradientColor1: '#ffb3ba',
  gradientColor2: '#bae1ff',
  gradientColor3: '#b8e6b8',
  uPositionFrequency: 2.38,
  uPositionStrength: 0,
  uSmallWavePositionFrequency: 0.53,
  uSmallWavePositionStrength: 0.53,
  uSmallWaveTimeFrequency: 0.04,
  uTimeFrequency: 2,
  roughness: 1,
  metalness: 0,
  envMapIntensity: 0,
  clearcoat: 0,
  clearcoatRoughness: 0,
  transmission: 0,
  wireframe: false,
  flatShading: false,
  autoRotate: false,
  autoRotateSpeed: 5.7,
};
